// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".featured .featured-card-bg{background-size:cover;background-position:50%}.featured .featured-card-bg p,.featured .featured-card-bg span{margin-bottom:16px}.flex-equal>div{flex:1!important}.flex-equal .featured-card-catering{flex-direction:column-reverse;border-bottom-right-radius:20px}", ""]);
// Exports
module.exports = exports;
